import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="content has-text-centered">
          <div className="soc">
            <a
              href="https://dk.linkedin.com/in/francesco-chiaro-1a647115"
              title="linkedin"
            >
              <i className="fa fa-linkedin fa-2x"></i>
            </a>
            <a href="">
              <i className="fa fa-instagram fa-2x"></i>
            </a>
            <a href="">
              <i className="fa fa-facebook fa-2x"></i>
            </a>
            <a href="">
              <i className="fa fa-twitter fa-2x"></i>
            </a>
          </div>
          <p>
            <strong>Flickr Gallery</strong> by{" "}
            <a href="https://francescochiaro.dk">Francesco Chiaro</a>. The
            source code is licensed{" "}
            <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
            <br />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js